import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import ca_commodity from "assets/images/ca_commodity.svg";
import { LinkButton } from "components/buttons";
import { Link } from "react-router-dom";

function CommodityMurabahahBiz() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Deposits"
          title={`Commodity Murabahah
              <span className="jumbotron-subtitle-2">
                Current Account-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Introducing our flexible current account, designed to combine the
              essential features of a traditional account with the added benefit
              of earning profit on your deposits. Contact us to learn more about
              how we can support your business's financial goals.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Attractive Profit Rates</div>
                <div className="column-subheader">
                  Earn attractive returns under simple tier rates
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Minimum Balance</div>
                <div className="column-subheader">
                  No minimum balance to maintain{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial Deposit</div>
                <div className="column-subheader">
                  Minimal initial deposit of RM3,000 (for Non-individual){" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah Contract</div>
                <div className="column-subheader">
                  Commodity Murabahah (via Tawarruq arrangement){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features & Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Protected by PIDM </div>
                <div className="column-subheader-2">
                  Up to RM250,000 for each depositor{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Convenient</div>
                <div className="column-subheader-2">
                  Convenient with alrajhicashbiz@24seven to facilitate your
                  business transactions effectively{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4"></div>
          <div className="col-xl-8">
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <LinkButton
                text="Board Rate"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/CMCA-i Board Rate.pdf"
                  )
                }
              />

              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/1657884442_PRODUCT DISCLOSURE SHEET (PDS) - Commodity Murabahah Current Account-i.pdf"
                  )
                }
              />
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/1595920677_Deposit - all fees and charges_280720.pdf"
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CommodityMurabahahBiz;
